var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-header-wrapper",
    [
      _c(
        "a-card",
        [
          _vm.$access("ENT_UR_USER_SEARCH")
            ? _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      staticClass: "table-head-ground",
                      attrs: { layout: "inline" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "table-layer" },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "" } },
                            [
                              _c("jeepay-text-up", {
                                attrs: {
                                  placeholder: "用户ID",
                                  msg: _vm.searchData.sysUserId,
                                },
                                model: {
                                  value: _vm.searchData.sysUserId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchData, "sysUserId", $$v)
                                  },
                                  expression: "searchData.sysUserId",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            { attrs: { label: "" } },
                            [
                              _c("jeepay-text-up", {
                                attrs: {
                                  placeholder: "用户姓名",
                                  msg: _vm.searchData.realname,
                                },
                                model: {
                                  value: _vm.searchData.realname,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchData, "realname", $$v)
                                  },
                                  expression: "searchData.realname",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            { staticClass: "table-page-search-submitButtons" },
                            [
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    icon: "search",
                                    loading: _vm.btnLoading,
                                  },
                                  on: { click: _vm.searchFunc },
                                },
                                [_vm._v("查询")]
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  attrs: { icon: "reload" },
                                  on: { click: () => (this.searchData = {}) },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    [
                      _vm.$access("ENT_UR_USER_ADD")
                        ? _c(
                            "a-button",
                            {
                              staticClass: "mg-b-30",
                              attrs: { type: "primary", icon: "plus" },
                              on: { click: _vm.addFunc },
                            },
                            [_vm._v("新建")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("JeepayTable", {
            ref: "infoTable",
            attrs: {
              initData: true,
              reqTableDataFunc: _vm.reqTableDataFunc,
              tableColumns: _vm.tableColumns,
              searchData: _vm.searchData,
              rowKey: "sysUserId",
            },
            on: {
              btnLoadClose: function ($event) {
                _vm.btnLoading = false
              },
            },
            scopedSlots: _vm._u([
              {
                key: "avatarSlot",
                fn: function ({ record }) {
                  return [
                    _c("a-avatar", {
                      attrs: { size: "default", src: record.avatarUrl },
                    }),
                  ]
                },
              },
              {
                key: "stateSlot",
                fn: function ({ record }) {
                  return [
                    _c("JeepayTableColState", {
                      attrs: {
                        state: record.state,
                        showSwitchType: _vm.$access("ENT_UR_USER_EDIT"),
                        onChange: (state) => {
                          return _vm.updateState(record.sysUserId, state)
                        },
                      },
                    }),
                  ]
                },
              },
              {
                key: "opSlot",
                fn: function ({ record }) {
                  return [
                    _c("JeepayTableColumns", [
                      _vm.$access("ENT_UR_USER_UPD_ROLE")
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.roleDist(record.sysUserId)
                                },
                              },
                            },
                            [_vm._v("变更角色")]
                          )
                        : _vm._e(),
                      _vm.$access("ENT_UR_USER_EDIT")
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.editFunc(record.sysUserId)
                                },
                              },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.$access("ENT_UR_USER_DELETE")
                        ? _c(
                            "a",
                            {
                              staticStyle: { color: "red" },
                              on: {
                                click: function ($event) {
                                  return _vm.delFunc(record.sysUserId)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          )
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("InfoAddOrEdit", {
        ref: "infoAddOrEdit",
        attrs: { callbackFunc: _vm.searchFunc },
      }),
      _c("RoleDist", { ref: "roleDist" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }